import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { onAuthStateChanged, signOut } from "firebase/auth";

// Create Authentication Context
const AuthContext = createContext();

// AuthProvider Component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(() => localStorage.getItem("role") || "client"); // Get from localStorage

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const storedRole = localStorage.getItem("role") || "client";
        setRole(storedRole);
      } else {
        setUser(null);
        setRole("client");
      }
    });

    return () => unsubscribe();
  }, []);

  // Update role & store in localStorage
  const updateRole = (newRole) => {
    setRole(newRole);
    localStorage.setItem("role", newRole);
  };

  // Logout Function
  const logout = async () => {
    try {
      await signOut(auth);
      setUser(null);
      setRole("client");
      localStorage.removeItem("role");
    } catch (error) {
      console.error("Logout Error:", error.message);
    }
  };

  return (
    <AuthContext.Provider value={{ user, role, setRole: updateRole, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom Hook for using AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};
